import { Image } from "@at/design-system-elements";
import { ThemeSelectors, TypeInsignia } from "@at/design-system-foundation";
import styled, { css } from "styled-components";

export const Content = styled.section`
  + div {
    margin-top: ${({ theme }) => ThemeSelectors.getRelatedTwoSpacing(theme)};

    .atds-modal--close {
      width: 100%;
      border-radius: 40px;
      padding: 15px 24px;
    }
  }
`;

export const Title = styled(TypeInsignia).attrs({ as: "h3" })`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
  font-variation-settings: "wght" 400;
`;

export const VideoWrapper = styled.div`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
`;

export const Thumbnail = styled.div`
  width: 100%;
  position: relative;
`;

export const ThumbnailImage = styled(Image)`
  img {
    width: 100%;
    height: 100%;
  }
`;

export const PlayButton = styled.button`
  box-sizing: border-box;
  margin: auto;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 80px;
  height: 80px;
  padding-top: 14px;
  padding-left: 8px;
  line-height: 20px;
  border: 2px solid #fff;
  border-radius: 50%;
  color: #f5f5f5;
  text-align: center;
  text-decoration: none;
  background-color: rgba(102, 102, 102, 0.6);
  font-size: 20px;
  font-weight: bold;
  font-variation-settings: "wght" 700;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(102, 102, 102, 0.6);
    box-shadow: 0px 0px 10px rgba(255, 255, 100, 0.8);
    text-shadow: 0px 0px 10px rgba(255, 255, 100, 1);
  }

  &::after {
    content: "";
    display: inline-block;
    position: relative;
    top: -5px;
    left: 3px;
    border-style: solid;
    border-width: 10px 0 10px 20px;
    border-color: transparent transparent transparent white;
  }
`;

export const Video = styled.iframe`
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9;
  border: none;
`;

export const Body = styled.div<{ isVans?: boolean }>`
  margin-bottom: ${({ theme }) => ThemeSelectors.getRelatedTwoSpacing(theme)};
  color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};

  ${({ isVans }) => {
    if (isVans) {
      return css`
        margin-bottom: ${({ theme }) =>
          ThemeSelectors.getGroupFiveSpacing(theme)};
      `;
    }
  }}
`;

export const FAQsTitle = styled(TypeInsignia).attrs({
  as: "h3",
  weight: "300",
})`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
`;
